import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frenchTextPositions'
})
export class FrenchTextPositionsPipe implements PipeTransform {

  transform(numero: any, isMasculin = true): string {
    const masculinPositions = ['premier', 'deuxième', 'troisième', 'quatrième', 'cinquième', 'sixième', 'septième', 'huitième', 'neuvième', 'dixième'];
    if (!isMasculin) { masculinPositions[0] = 'première'; }
    const intNumero = parseInt(numero, 10);
    // if the position is not declared int the array, we return the given number
    if (intNumero > masculinPositions.length ) { return numero.toString(); }
    return masculinPositions[intNumero];
  }

}
